module.exports = __webpack_public_path__ + "img/ico_checkout_error.94468364.svg";